import React from 'react'

import { Col, Form } from '_zari/core'

import { Select2CuentaContable } from 'sharedComponents/select2'
import { ClearInputGroup } from 'sharedComponents/utils'

import { KeyEventUtil } from 'utils'

const CuentaContableClase7FormGroup = ({ iError, iTouched, setFieldValue, iValue }) => {
  const onChange = React.useCallback(
    salida => {
      setFieldValue('cuentaContableClase7', salida.value)
      setFieldValue('cuentaContableClase7Info', salida.label)
      KeyEventUtil.leaveOnKeyEvent('input-depreciacionAnual')
    },
    [setFieldValue]
  )

  const clickClear = React.useCallback(() => {
    setFieldValue('cuentaContableClase7', '')
    setFieldValue('cuentaContableClase7Info', '')
    KeyEventUtil.leaveOnKeyEvent('select-cuentaContableClase7')
  }, [setFieldValue])

  return (
    <Form.Group>
      <Form.Label
        text='CC. CLASE 7'
        htmlFor='select-cuentaContableClase7'
        md={4}
        alignRightAt='md'
      />
      <Col md={8}>
        {iValue ? (
          <ClearInputGroup id='cuentaContableClase7' iValue={iValue} clickClear={clickClear} />
        ) : (
          <Select2CuentaContable
            id='select-cuentaContableClase7'
            onlyAnalitica
            onChange={onChange}
          />
        )}
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(CuentaContableClase7FormGroup)
